module.exports = __webpack_public_path__ + "assets/img/8345dfac6c731fe190b7d360277a9fec.png";